import { Stack } from '../shared/layouts';
import { useTheme } from '@emotion/react';
import Header from '../shared/Header';
import Placeholder from '../shared/Placeholder';
import { useMediaQuery } from '@dnhb/node_package';
import { useLocation } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import useIconLibrary from "../../hooks/useIconLibrary";

const ProductsPage = () => {
  const { t } = useTranslation();
  const { breakpoints } = useTheme();
  const isMinDesktop = useMediaQuery(
    `(min-width: ${breakpoints.ml ?? '56.25rem'})`
  );
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);
  const noProducts = urlSearchParams.get('empty');
  const { ProductIcon } = useIconLibrary();

  return (
    <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
      <Header
        title={t("Producten")}
        icon={isMinDesktop ? <ProductIcon height="2rem" width="2rem" /> : null}
        variant="page"
      />
      <Placeholder>
        {noProducts
          ? t('Je hebt op dit moment geen producten')
          : t('Gebruik het uitklapmenu om je producten te bekijken')}
      </Placeholder>
    </Stack>
  );
};

export default ProductsPage;
